module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_k-1a0ba5853f64129c967ff8f133d5ac98.png";